// extracted by css-extract-rspack-plugin
export default {"cls1":"SocialActionsMenu-cls1_nVn","cls2":"SocialActionsMenu-cls2_orq SocialActionsMenu-cls1_nVn"};